const theme = {
  colorPrimary: "#f2f2f2",
  colorAccent: "#115571",
  colorLight: "#31afb4",
  colorTextPrimary: "#25282c",
  colorTextAccent: "#ffffff",
  colorTextLight: "#eee3d5",
  colorDarken: "rgba(0,0,0,0.3)",
  colorFooter: "#115571",
  tabletSize: "900px",
  desktopSize: "1920px",
  fontPrimary: "Montserrat, Verdana, Geneva, Tahoma, sans-serif",
  fontSecundary: "Roboto, Arial, Helvetica, sans-serif",
};

export default theme;